import React from "react";

interface AddProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
  onClick?: () => void;
}
const IconUserLg: React.FC<AddProps> = ({ className, width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height} viewBox="0 0 32 30.118" fill="none">
    <path
      d="M16 15.059q-3.106 0-5.318-2.212T8.471 7.529t2.212-5.318T16 0t5.318 2.212 2.211 5.317-2.212 5.318T16 15.059M.941 26.353v-1.506q0-1.6.824-2.94.823-1.342 2.187-2.048a28.2 28.2 0 0 1 5.929-2.189A26 26 0 0 1 16 16.941q3.106 0 6.118.728 3.012.73 5.929 2.189 1.363.706 2.187 2.046.824 1.342.824 2.942v1.506q0 1.553-1.107 2.658a3.63 3.63 0 0 1-2.657 1.108H4.706q-1.553 0-2.658-1.107a3.63 3.63 0 0 1-1.107-2.658m3.765 0h22.588v-1.506a1.83 1.83 0 0 0-.941-1.6q-2.541-1.271-5.129-1.905a21.84 21.84 0 0 0-10.447 0q-2.589.634-5.13 1.905a1.83 1.83 0 0 0-.941 1.6zM16 11.294q1.553 0 2.658-1.107 1.107-1.103 1.107-2.658 0-1.551-1.107-2.658A3.63 3.63 0 0 0 16 3.765q-1.551 0-2.658 1.105a3.63 3.63 0 0 0-1.107 2.659q0 1.551 1.107 2.658 1.105 1.107 2.658 1.107"
      fill="#1C1B1F"
    />
  </svg>
);
export default IconUserLg;
